<!-- container-xxl -->
<div class="content-wrapper p-0">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="content-body">
      <!-- app e-commerce details start -->
      <section class="app-ecommerce-details">
        <!-- <div class="card"> -->
          <!-- Related Products starts -->
          <!-- <div class="card-body"> -->
            <form class="auth-login-form mt-2" [formGroup]="impDocumentForm" >
              <!-- <div class="row">
                <div class="form-group col-md-4">
                  <ng-select [items]="category" bindLabel="categoryName" formControlName="catagortyType" bindValue="categoryID"> </ng-select>
                </div>
              </div> -->
            </form>
            <div class="row ImportantDocs-outer-container">
            <div class="form-group col-md-12">
              <ul class="nobull ">
                <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/RnD_Programme_RE_RTD.pdf" target="_blank">i. Renewable Energy Research and Technology Development (RE-RTD) Programme (RE-RTD)</a></p></li>
                <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/RnD_format_for_submission_of_proposal.docx" target="_blank">ii. R&D Format (PI is requested to make ready word file as per R&D Format before submitting application)</a></p></li>
                <!-- <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/Certificate_from_the_Principal_Investigator_and_Grantee_organization.docx" target="_blank">iii. Certificate from the Principal Investigator and Grantee organization (On the letter head of the Organization)</a></p></li>
                <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/Endorsement_by_the_Head_of_the_Institution.docx" target="_blank">iv. Endorsement by the Head of the Institution </a></p></li> -->
                <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/Gerneral_TnD.pdf" target="_blank">iii. General T&C </a></p></li>
              </ul>
              
              <ul class="nobull">
                <li><h5><p>Other Documents</p></h5></li>
                <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/Final_MoM_for_Review_of_RD_scheme_MNRE.pdf" target="_blank">i. Final MoM for Review of RD scheme_MNRE </a></p></li>
                <li><p><a href="{{documentURL}}/documentUploads/ImportantDocs/RnD_Review_Report.pdf" target="_blank">ii. R&D Review Report </a></p></li>
              </ul>
            </div>
          </div>
          <!-- </div> -->
        <!-- </div> -->
      </section>
    </div>
  </div>
  